import { render, staticRenderFns } from "./invoiceMessage.vue?vue&type=template&id=6b39f7ef&scoped=true"
import script from "./invoiceMessage.vue?vue&type=script&lang=js"
export * from "./invoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./invoiceMessage.vue?vue&type=style&index=0&id=6b39f7ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39f7ef",
  null
  
)

export default component.exports